// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var DateUtils = require("../../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ApolloUtils = require("../../../../shared/src/ApolloUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebGraphql_Shifts = require("../../graphql/WebGraphql_Shifts.bs.js");
var WebTypes_NewShift = require("../../types/WebTypes_NewShift.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_State = require("../../store/WebStore_Types_State.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var WebGraphql_CurrentUser = require("../../graphql/WebGraphql_CurrentUser.bs.js");
var WebTypes_PostAShift_Step = require("../../types/WebTypes_PostAShift_Step.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var WebComponents_ProgressHeader = require("../../components/WebComponents_ProgressHeader.bs.js");
var WebContainers_PostAShift_ShiftType = require("./WebContainers_PostAShift_ShiftType.bs.js");
var WebContainers_PostAShift_ShiftDates = require("./WebContainers_PostAShift_ShiftDates.bs.js");
var WebContainers_PostAShift_ShiftDetails = require("./WebContainers_PostAShift_ShiftDetails.bs.js");
var WebContainers_PostAShift_ShiftLocation = require("./WebContainers_PostAShift_ShiftLocation.bs.js");
var WebContainers_PostAShift_ShiftConfirmation = require("./WebContainers_PostAShift_ShiftConfirmation.bs.js");

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: /* [] */0
      }
    });

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexDirection(BrowserStyle.column),
          tl: {
            hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
            tl: {
              hd: BrowserStyle.minHeight(BrowserStyle.zero),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  content: content,
  wrapper: wrapper
};

function WebContainers_PostAShift$Presentation(Props) {
  var authorizedClient = Props.authorizedClient;
  var availableShiftSteps = Props.availableShiftSteps;
  var copyFromShiftId = Props.copyFromShiftId;
  var currentShiftStep = Props.currentShiftStep;
  var fetchCopiedShift = Props.fetchCopiedShift;
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var fetchMinHourlyRate = Props.fetchMinHourlyRate;
  var fetchRequestableWorkers = Props.fetchRequestableWorkers;
  var fetchSavedLocationsForCurrentUser = Props.fetchSavedLocationsForCurrentUser;
  var fetchSavedManagers = Props.fetchSavedManagers;
  var fetchShiftTypes = Props.fetchShiftTypes;
  var layout = Props.layout;
  var newShift = Props.newShift;
  var phoneNumberIsAvailable = Props.phoneNumberIsAvailable;
  var postShifts = Props.postShifts;
  var requestableWorkers = Props.requestableWorkers;
  var resetAndNavigateBack = Props.resetAndNavigateBack;
  var savedLocations = Props.savedLocations;
  var savedManagers = Props.savedManagers;
  var setToMinimumShiftStep = Props.setToMinimumShiftStep;
  var shiftTypes = Props.shiftTypes;
  var updateNewShift = Props.updateNewShift;
  var param = Props.user;
  var city = param.city;
  var timezone = city.timezone;
  var cityId = city.id;
  var match = param.business;
  var tipsPaidByQwickMarkup = match.tipsPaidByQwickMarkup;
  var markupRate = match.markupRate;
  var enableRequestedWorkers = match.enableRequestedWorkers;
  var dates = newShift.dates;
  ReactIO.useHandledIOOnMount(undefined)(Relude_IO.flatMap((function (param) {
              return fetchShiftTypes;
            }), Curry._2(IOUtils.IOWithUnitError.mapTuple4, (function (param, param$1, param$2, param$3) {
                  
                }), [
                fetchSavedLocationsForCurrentUser,
                fetchSavedManagers,
                fetchRequestableWorkers,
                Relude_Option.fold(Relude_IO.pure(undefined), fetchCopiedShift, copyFromShiftId)
              ])));
  var goBack = Curry._1(setToMinimumShiftStep, Relude_Option.getOrElse(WebTypes_PostAShift_Step.bottom, Curry._1(WebTypes_PostAShift_Step.pred, currentShiftStep)));
  var postShifts$1 = function (param) {
    return Relude_Globals.$great$great(postShifts, (function (param) {
                  return Relude_IO.flatMap((function (param) {
                                var partial_arg = ApolloUtils.createErrorMessage("Could not finish posting shifts", undefined, undefined, undefined);
                                return Curry._2(Relude_IO.mapError, (function (param) {
                                              return Relude_Globals.$$const(partial_arg, param);
                                            }), resetAndNavigateBack);
                              }), param);
                }), param);
  };
  var partial_arg = React.createElement(BrowserComponents_Loading.make, {});
  return Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.$$Screen.make, {}), (function (param) {
                var tmp;
                switch (currentShiftStep) {
                  case /* Location */0 :
                      tmp = React.createElement(WebContainers_PostAShift_ShiftLocation.make, {
                            authorizedClient: authorizedClient,
                            city: city,
                            fetchGeocodeForAddress: fetchGeocodeForAddress,
                            newShift: newShift,
                            onCancel: resetAndNavigateBack,
                            savedLocations: param[1],
                            setShiftLocation: (function ($$location) {
                                return Curry._2(updateNewShift, Relude_Option.getOrElse(WebTypes_PostAShift_Step.top, Curry._1(WebTypes_PostAShift_Step.succ, currentShiftStep)), {
                                            basicInfo: newShift.basicInfo,
                                            dates: newShift.dates,
                                            details: newShift.details,
                                            location: Relude_Option.pure($$location)
                                          });
                              })
                          });
                      break;
                  case /* DateTime */1 :
                      tmp = React.createElement(WebContainers_PostAShift_ShiftDates.make, {
                            newShift: newShift,
                            setShiftDates: (function (dates) {
                                return Curry._2(updateNewShift, Relude_Option.getOrElse(WebTypes_PostAShift_Step.top, Curry._1(WebTypes_PostAShift_Step.succ, currentShiftStep)), {
                                            basicInfo: newShift.basicInfo,
                                            dates: Relude_Option.pure(dates),
                                            details: newShift.details,
                                            location: newShift.location
                                          });
                              }),
                            goBack: goBack,
                            layout: layout,
                            timezone: timezone
                          });
                      break;
                  case /* BasicInfo */2 :
                      tmp = React.createElement(WebContainers_PostAShift_ShiftType.make, {
                            enableRequestedWorkers: enableRequestedWorkers,
                            fetchMinHourlyRate: (function (shiftTypeId) {
                                return Relude_Option.fold(Relude_IO.$$throw(undefined), fetchMinHourlyRate, Relude_Option.map((function (param) {
                                                  return {
                                                          cityId: cityId,
                                                          shiftTypeId: shiftTypeId,
                                                          startDatetime: param.startDatetime,
                                                          endDatetime: param.endDatetime
                                                        };
                                                }), Curry._2(Relude_Option.flatMap, (function (param) {
                                                      return Relude_Globals.$great$great((function (param) {
                                                                    return Relude_Globals.$great$great(WebTypes_NewShift.Dates.makeShiftDates, (function (param) {
                                                                                  return Relude_Array.sortBy((function (param, param$1) {
                                                                                                return Curry._2(DateUtils.compare(undefined, undefined), param.startDatetime, param$1.startDatetime);
                                                                                              }), param);
                                                                                }), param);
                                                                  }), Relude_Array.head, param);
                                                    }), dates)));
                              }),
                            goBack: goBack,
                            markupRate: markupRate,
                            newShift: newShift,
                            requestableWorkers: param[0],
                            setBasicInfo: (function (basicInfo) {
                                return Curry._2(updateNewShift, Relude_Option.getOrElse(WebTypes_PostAShift_Step.top, Curry._1(WebTypes_PostAShift_Step.succ, currentShiftStep)), {
                                            basicInfo: Relude_Option.pure(basicInfo),
                                            dates: newShift.dates,
                                            details: newShift.details,
                                            location: newShift.location
                                          });
                              }),
                            shiftTypes: param[3],
                            tipsPaidByQwickMarkup: tipsPaidByQwickMarkup
                          });
                      break;
                  case /* Details */3 :
                      tmp = React.createElement(WebContainers_PostAShift_ShiftDetails.make, {
                            goBack: goBack,
                            newShift: newShift,
                            phoneNumberIsAvailable: phoneNumberIsAvailable,
                            savedManagers: param[2],
                            setDetails: (function (details) {
                                return Curry._2(updateNewShift, Relude_Option.getOrElse(WebTypes_PostAShift_Step.top, Curry._1(WebTypes_PostAShift_Step.succ, currentShiftStep)), {
                                            basicInfo: newShift.basicInfo,
                                            dates: newShift.dates,
                                            details: Relude_Option.pure(details),
                                            location: newShift.location
                                          });
                              })
                          });
                      break;
                  case /* Confirmation */4 :
                      tmp = React.createElement(WebContainers_PostAShift_ShiftConfirmation.make, {
                            goBack: goBack,
                            markupRate: markupRate,
                            newShift: newShift,
                            postShifts: postShifts$1,
                            setToMinimumShiftStep: setToMinimumShiftStep,
                            timezone: timezone
                          });
                      break;
                  
                }
                return React.createElement("main", {
                            className: wrapper
                          }, React.createElement(WebComponents_ProgressHeader.make, {
                                activeStep: currentShiftStep,
                                availableShiftSteps: availableShiftSteps,
                                onCancel: resetAndNavigateBack,
                                setActiveStep: setToMinimumShiftStep
                              }), React.createElement(BrowserComponents_FlexRow.make, {
                                className: content,
                                children: tmp
                              }));
              }), (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), Curry._2(WebStore_Types_State.AsyncResultWithDispatchError.mapTuple4, (function (requestableWorkers, savedLocations, savedManagers, shiftTypes) {
                    return [
                            requestableWorkers,
                            savedLocations,
                            savedManagers,
                            shiftTypes
                          ];
                  }), [
                  requestableWorkers,
                  savedLocations,
                  savedManagers,
                  shiftTypes
                ]));
}

var Presentation = {
  make: WebContainers_PostAShift$Presentation
};

var mapStateToProps = Reselect.createSelector9(undefined, WebStore_Selectors.getAuthorizedClient, (function (param) {
        return param.postAShift.shiftTypes;
      }), (function (param) {
        return param.postAShift.availableShiftSteps;
      }), (function (param) {
        return param.postAShift.currentShiftStep;
      }), (function (param) {
        return param.postAShift.newShift;
      }), (function (param) {
        return param.savedLocations;
      }), (function (param) {
        return param.postAShift.savedManagers;
      }), (function (param) {
        return param.postAShift.requestableWorkers;
      }), (function (param) {
        return param.layout;
      }), (function (authorizedClient, shiftTypes, availableShiftSteps, currentShiftStep, newShift, savedLocations, savedManagers, requestableWorkers, layout) {
        return {
                authorizedClient: authorizedClient,
                availableShiftSteps: availableShiftSteps,
                currentShiftStep: currentShiftStep,
                layout: layout,
                newShift: newShift,
                requestableWorkers: requestableWorkers,
                savedLocations: savedLocations,
                savedManagers: savedManagers,
                shiftTypes: shiftTypes
              };
      }));

function mapDispatchToProps(dispatch, param) {
  var authorizedClient = param.authorizedClient;
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  return {
          fetchCopiedShift: (function (param) {
              return Relude_Globals.$great$great((function (param) {
                            return Relude_Globals.$great$great((function (param) {
                                          return Relude_Globals.$great$great(WebStore_Types_Action.PostAShift.copyShiftById, WebStore_Types_Action.postAShift, param);
                                        }), dispatch, param);
                          }), partial_arg, param);
            }),
          fetchGeocodeForAddress: (function (address) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_Shifts.GeocodeAddress.query, address);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          fetchMinHourlyRate: (function (variables) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_Shifts.GetShiftRateStats.query, variables);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          fetchRequestableWorkers: Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.fetchRequestableWorkers))),
          fetchSavedLocationsForCurrentUser: Relude_IO.flatMap((function (param) {
                  return Curry._2(Relude_IO.mapError, (function (prim) {
                                
                              }), Curry._1(dispatch, WebStore_Types_Action.fetchSavedLocationsForCurrentUser));
                }), Curry._2(Relude_IO.mapError, (function (prim) {
                      
                    }), Curry._1(dispatch, WebStore_Types_Action.fetchUser))),
          fetchSavedManagers: Relude_IO.flatMap((function (param) {
                  return Curry._2(Relude_IO.mapError, (function (prim) {
                                
                              }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.fetchSavedManagers)));
                }), Curry._2(Relude_IO.mapError, (function (prim) {
                      
                    }), Curry._1(dispatch, WebStore_Types_Action.fetchUser))),
          fetchShiftTypes: Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.fetchShiftTypes))),
          phoneNumberIsAvailable: (function (phoneNumber) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_CurrentUser.PhoneNumberAvailable.query, phoneNumber);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          postShifts: (function (newShift) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
                      return ApolloUtils.createErrorMessage("Could not display newly posted shifts - please refresh", undefined, undefined, undefined);
                    }));
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great((function (param) {
                                          return Relude_Globals.$great$great((function (param) {
                                                        return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateManyShifts, WebStore_Types_Action.dashboard, param);
                                                      }), dispatch, param);
                                        }), partial_arg, param);
                          }), Relude_IO.flatMap(Curry._1(WebGraphql_Shifts.PostShifts.mutate, newShift), Relude_IO.fromOption((function (param) {
                                    return ApolloUtils.createErrorMessage("No client", undefined, undefined, undefined);
                                  }), authorizedClient)));
            }),
          resetAndNavigateBack: Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Relude_IO.flatMap((function (param) {
                      return Curry._1(dispatch, WebStore_Types_Action.setView({
                                      TAG: /* BusinessDashboard */0,
                                      _0: {
                                        TAG: /* ShiftsList */1,
                                        _0: /* Upcoming */1
                                      }
                                    }));
                    }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.reset)))),
          setToMinimumShiftStep: (function (shiftStep) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.setToMinimumShiftStep(shiftStep))));
            }),
          updateNewShift: (function (minimumShiftStep, newShift) {
              return Curry._2(IOUtils.IOWithUnitError.mapTuple2, (function (param, param$1) {
                            
                          }), [
                          Curry._2(Relude_IO.mapError, (function (prim) {
                                  
                                }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.updateNewShift(newShift)))),
                          Curry._2(Relude_IO.mapError, (function (prim) {
                                  
                                }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.setToMinimumShiftStep(minimumShiftStep))))
                        ]);
            })
        };
}

function WebContainers_PostAShift(Props) {
  var copyFromShiftId = Props.copyFromShiftId;
  var user = Props.user;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  var tmp = {
                    authorizedClient: param.authorizedClient,
                    availableShiftSteps: param.availableShiftSteps,
                    currentShiftStep: param.currentShiftStep,
                    fetchCopiedShift: param$1.fetchCopiedShift,
                    fetchGeocodeForAddress: param$1.fetchGeocodeForAddress,
                    fetchMinHourlyRate: param$1.fetchMinHourlyRate,
                    fetchRequestableWorkers: param$1.fetchRequestableWorkers,
                    fetchSavedLocationsForCurrentUser: param$1.fetchSavedLocationsForCurrentUser,
                    fetchSavedManagers: param$1.fetchSavedManagers,
                    fetchShiftTypes: param$1.fetchShiftTypes,
                    layout: param.layout,
                    newShift: param.newShift,
                    phoneNumberIsAvailable: param$1.phoneNumberIsAvailable,
                    postShifts: param$1.postShifts,
                    requestableWorkers: param.requestableWorkers,
                    resetAndNavigateBack: param$1.resetAndNavigateBack,
                    savedLocations: param.savedLocations,
                    savedManagers: param.savedManagers,
                    setToMinimumShiftStep: param$1.setToMinimumShiftStep,
                    shiftTypes: param.shiftTypes,
                    updateNewShift: param$1.updateNewShift,
                    user: user
                  };
                  if (copyFromShiftId !== undefined) {
                    tmp.copyFromShiftId = Caml_option.valFromOption(copyFromShiftId);
                  }
                  return React.createElement(WebContainers_PostAShift$Presentation, tmp);
                })
            });
}

var ShiftConfirmation;

var ShiftDates;

var ShiftDetails;

var ShiftLocation;

var ShiftType;

var make = WebContainers_PostAShift;

exports.ShiftConfirmation = ShiftConfirmation;
exports.ShiftDates = ShiftDates;
exports.ShiftDetails = ShiftDetails;
exports.ShiftLocation = ShiftLocation;
exports.ShiftType = ShiftType;
exports.Styles = Styles;
exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* content Not a pure module */
